import { cn } from "@/utils/className";
import React from "react";

export interface BreadcrumbItem {
    label: string;
    href?: string;
    isActive?: boolean;
}

interface BreadcrumbProps {
    items: BreadcrumbItem[];
    className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className = "container pt-[4.68rem]" }) => {
    const separatorSvg = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='currentColor'/%3E%3C/svg%3E")`
    return (
        <div className={cn(className)}>
            <nav
                className="text-sm"
                style={{ ["--bs-breadcrumb-divider" as any]: separatorSvg }}
                aria-label="breadcrumb"
            >
                <ol className="flex flex-wrap list-none gap-y-1 mb-4">
                    {items.map((item, index) => {
                        const isLast = index === items.length - 1;
                        return (
                            <li
                                key={index}
                                className={cn(
                                    "flex items-center",
                                    !isLast && "after:content-[''] after:w-2 after:h-2 after:mx-2 after:inline-block",
                                    !isLast && "after:bg-[length:contain] after:bg-no-repeat after:bg-center",
                                    !isLast && "after:bg-[image:var(--bs-breadcrumb-divider)]"
                                )}
                            >
                                {item.href && !isLast ? (
                                    <a
                                        href={item.href}
                                        className="text-[var(--color-gray-900)] underline hover:text-[var(--color-gray-500)] transition-colors"
                                    >
                                        {item.label}
                                    </a>
                                ) : (
                                    <span className="text-[var(--color-gray-500)]">{item.label}</span>
                                )}
                            </li>
                        );
                    })}
                </ol>
            </nav>
        </div>
    );
};

export default Breadcrumb